export default "__VITE_ASSET__C1c6IzSg__"